import { render } from "./MainWizard.vue?vue&type=template&id=f405eb6e&scoped=true"
import script from "./MainWizard.vue?vue&type=script&lang=js"
export * from "./MainWizard.vue?vue&type=script&lang=js"

import "./MainWizard.vue?vue&type=style&index=0&id=f405eb6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f405eb6e"]])

export default __exports__